import { render, staticRenderFns } from "./BillingOrderAction.vue?vue&type=template&id=522bf9cb&scoped=true"
import script from "./BillingOrderAction.vue?vue&type=script&lang=js"
export * from "./BillingOrderAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522bf9cb",
  null
  
)

export default component.exports